export default __webpack_public_path__ + "static/media/home.cf4b5a73.png";